import axios from 'axios';
import authHeader from "@/service/auth-header";

class AlertService {

    async getUserAlerts(userId) {
        return await axios.get(`/api/applications/si/alert/${userId}`,{ headers: authHeader() })
    }

    async getUserActiveAlerts(userId) {
        return await axios.get(`/api/applications/si/alert/active/${userId}`,{ headers: authHeader() })
    }

    async searchAlerts(userId, searchCriteria) {
        console.log("[AlertService][searchAlerts] userId = ", userId);
        console.log("[AlertService][searchAlerts] searchCriteria = ", searchCriteria);
        return await axios.get(`/api/applications/si/alert/search/${userId}/${searchCriteria}`,{ headers: authHeader() })
    }

    async getAlert(id) {
        return await axios.get(`/api/applications/si/alert/specific/${id}`,{ headers: authHeader() })
    }

    async createAlert(userId, data) {
        return await axios.post(`/api/applications/si/alert/${userId}`, data,{ headers: authHeader() });
    }

    async updateAlert(id, data) {
        return await axios.put(`/api/applications/si/alert/${id}`, data,{ headers: authHeader() });
    }

    async deleteAlert(id) {
        return await axios.delete(`/api/applications/si/alert/${id}`,{ headers: authHeader() })
    }

}

export default new AlertService();
